export default "__VITE_ASSET__Do1Y_Ybb__"